import React from "react";
import { Image } from "moti";
import { View, Text, Pressable, StyleSheet, ImageBackground } from "react-native";
import Divider from "../../../common/layout/Divider/Divider";
import CustomProgressBar from "../../../common/general/CustomProgressBar/CustomProgressBar";
import TimeLeftSmall from "../../../svgs/common/TimeLeftSmall";
import CoreLabel from "../../../svgs/common/CoreLabel";
import ElectiveLabel from "../../../svgs/common/ElectiveLabel";
import GeneralLabel from "../../../svgs/common/GeneralLabel";
import CheckedBadge from "../../../svgs/common/CheckedBadge";
import { PlusCircle } from "../../../svgIcons";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import { shadowStyles } from "../../../../styles/shadow";
import Edit from "../../../svgs/common/Edit";
import { Certificate, ChartLine, GraduationCap, ThreeUsers } from "../../../svgs/common";
import RoundedLabel from "../../../common/label/RoundedLabel/RoundedLabel";
import CustomHtml from "../../../common/general/CustomHtml/CustomHtml";
import { LinearGradient } from "expo-linear-gradient";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomSpacing from "../../../common/layout/CustomSpacing/CustomSpacing";
import { useAppConfig } from "../../../../AppConfigProvider";

function CatalogueCard({
  title,
  cost,
  description,
  imageUrl,
  onEnrollPress,
  onDetailsPress,
  isLoading,
  degreeNames,
  userHasDegree,
}) {
  const { primaryColor } = useAppConfig();

  return (
    <View aria-label={`Course card ${title}`} style={styles.container}>
      <View style={{ width: "100%" }}>
        <ImageBackground source={{ uri: imageUrl }} style={styles.image} />
        {userHasDegree ? (
          <LinearGradient
            colors={["rgb(11, 44, 164)", "rgb(84, 0, 192)"]}
            locations={[0.3, 1]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={styles.infoBox}>
            <GraduationCap />
            <CustomText
              useTranslationText={false}
              aria-label="Degree name"
              role="header"
              aria-level="4"
              text="Degree Program"
              size="xs"
              weight="bold"
              style={{ color: "#FFFFFF" }}
            />
          </LinearGradient>
        ) : (
          <View style={[styles.infoBox, { backgroundColor: "#FFF" }]}>
            <ThreeUsers />
            <CustomText
              useTranslationText={false}
              aria-label="Public Course"
              role="header"
              aria-level="4"
              text="Public Course"
              size="xs"
              weight="bold"
              style={{ color: "#344054" }}
            />
          </View>
        )}
      </View>
      <CustomSpacing type="vertical" size="m" />
      <View style={styles.textContainer}>
        <View style={styles.upperSection}>
          <CustomText
            useTranslationText={false}
            role="header"
            aria-level="1"
            weight="ultraBold"
            text={title}
            size="m"
            style={{ color: "#101828" }}
          />
          <CustomSpacing type="vertical" size={degreeNames && degreeNames.length > 0 ? "xs" : "s"} />
          {degreeNames && degreeNames.length > 0 && (
            <>
              <View style={styles.degreeContainer}>
                <Certificate />
                <CustomText
                  useTranslationText={false}
                  role="header"
                  aria-level="2"
                  weight="bold"
                  text={`${degreeNames.join(", ")}`}
                  size="s"
                  style={{ color: "#344054" }}
                />
              </View>
              <CustomSpacing type="vertical" size="s" />
            </>
          )}
          {cost && (
            <>
              <CustomText
                useTranslationText={false}
                role="header"
                aria-level="2"
                weight="ultraBold"
                text={`$${cost}`}
                size="l"
                style={{ color: "#000" }}
              />
              <CustomSpacing type="vertical" size="s" />
            </>
          )}
          <CustomText
            useTranslationText={false}
            role="text"
            aria-level="3"
            weight="normal"
            text={description}
            size="s"
            style={{ color: "#667085", height: 60 }}
            numberOfLines={3}
            ellipsizeMode="tail"
          />
        </View>
        <View style={styles.lowerSection}>
          <CustomButton
            text="Course Details"
            styleType="primaryTransparent"
            onPress={onDetailsPress}
            textStyle={styles.detailsButtonText}
            style={{ paddingHorizontal: 0, paddingVertical: 6 }}
          />
          <CustomButton
            text="Enroll"
            onPress={onEnrollPress}
            style={[{ backgroundColor: primaryColor }, styles.enrollButtonStyle]}
            textStyle={styles.enrollButtonText}
            disabled={isLoading}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 24,
    overflow: "hidden",
    maxWidth: 570,
    minWidth: 400,
    width: "100%",
    borderColor: "#EAECF0",
    borderWidth: 1,
  },
  lowerSection: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderTopColor: "#EAECF0",
    borderTopWidth: 1,
    paddingTop: 16,
  },
  image: {
    width: "100%",
    height: 200,
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingHorizontal: 24,
    paddingBottom: 24,
    backgroundColor: "white",
    height: 239,
  },
  upperSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  enrollButtonText: {
    color: "white",
    fontWeight: "700",
  },
  enrollButtonStyle: {
    padding: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
  },
  detailsButtonText: {
    fontWeight: "700",
  },
  infoBox: {
    position: "absolute",
    top: 11,
    left: 14,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 100,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  degreeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
});

export default CatalogueCard;
